"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestUserPasswordWithEmailVerificationCodeResponse = exports.VerifyUserEmailVerificationCodeResponse = exports.CreateUserEmailVerificationCodeResponse = void 0;
class CreateUserEmailVerificationCodeResponse {
}
exports.CreateUserEmailVerificationCodeResponse = CreateUserEmailVerificationCodeResponse;
class VerifyUserEmailVerificationCodeResponse {
}
exports.VerifyUserEmailVerificationCodeResponse = VerifyUserEmailVerificationCodeResponse;
class RestUserPasswordWithEmailVerificationCodeResponse {
}
exports.RestUserPasswordWithEmailVerificationCodeResponse = RestUserPasswordWithEmailVerificationCodeResponse;
//# sourceMappingURL=userEmailVerifyCode.js.map